import { Message,Loading} from 'element-ui';


//简单封装axios
import axios from 'axios'
import qs from "qs"
import router from '../router'


let https = function (url, data, method) {

    // 每个接口都需要token，判断是否是登录之后（登录前没有token）
    let token  = sessionStorage.getItem('TOKEN');
    if(token){
      
        let arr = token.split('_')
        let time = new Date().valueOf()
        if(time>arr[0]){
         // token过期
         loadingFn()
        }
     
        // if(token.substr(0,1) =='"'){
        //     token = token.substring(1,token.length-1)
        // }
        // data.token =  token;
       
    }else if(url != "https://hzshixiang.site/pc/manager/login" && !token){
         // token过期
         loadingFn()
    }

    return new Promise((resolve,reject) => {
        if (method == 'POST') {
            axios.post(url, data,{
                // headers: {
                //     'Content-Type': 'application/json;charset=utf-8'
                // }
            }).then(res => {
                if (res.data.code == 1 || res.data.code == 200) {
                    resolve(res);
                }else if(res.data.code == 202){
                     // token过期
                     loadingFn()
                } 
                else {
                    resolve(res);
                    // Message.error(res.data.msg);
                }
            }).catch(err => {
                if (err.message.indexOf('timeout') !== -1) {
                    Message.error('请求超时');
                } else {
                    resolve(err);
                    // Message.error(err.data.msg);
                }
                reject(err)
            })
        } else if (method == 'GET') {
            axios.get(url, { params: data }).then(res => {
                // resolve(res);
                if (res.data.code == 1 || res.data.code == 200) {
                    resolve(res);
                }else if(res.data.code == 202){
                    // token过期
                    loadingFn()
                } else {
                    resolve(res);
                    // Message.error(res.data.msg);
                }
            }).catch(err => {
                Message.error('网络请求错误');
                reject(err)
            })
        }
    });
}

function loadingFn(){
    const loading = Loading.service({
        lock: true,
        text: '登录过期，请重新登陆',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        sessionStorage.removeItem('USER')
        sessionStorage.removeItem('TOKEN')
        loading.close();
        router.replace({
            path:"/Login"
        })
      }, 2000);
}


export default {https,loadingFn}


// WEBPACK FOOTER //
// ./src/util/https.js